import i18n from "@/libs/i18n";
import router from "@/router";

export default {
    async get({commit}, data) {
        commit('loadingStart', null, {root: true});
        const filters = window.mapFilterData(data);
        await this._vm.$http
            .get(`talka_business/list_orders${filters}`)
            .then(respo => {
                // console.log(respo.data)
                if (respo.status === 200) {
                    commit('setData', respo.data.data);

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

  async detail({commit}, id) {
    commit('loadingStart', null, {root: true});

    await this._vm.$http
      .get(`talka_business/show_order/${id}`)
      .then(respo => {
        if (respo.status === 200) {
          console.log(respo.data.data);
          commit('setDetail', respo.data.data);
          // commit('setProducts', []);
          commit('loadingFinish', null, {root: true});

        }
      })
      .catch(error => {
        commit('loadingFinish', null, {root: true});
        throw error;
      },);
  },

  async changeStatus({commit}, data) {
    commit('loadingStart', null, {root: true});

    await this._vm.$http
      .post(`talka_business/change_status/${data.order_id}`, {order_id: data.order_id, status: data.status})
      .then(respo => {
        if (respo.status === 200) {
          console.log(respo.data.data);
          commit('updateOrderDetail', respo.data.data);
          commit('loadingFinish', null, {root: true});

        }
      })
      .catch(error => {
        commit('loadingFinish', null, {root: true});
        throw error;
      },);
  },

  async cancel({ commit }, data) {
    commit('loadingStart', null, {root: true});

    await this._vm.$http
      .post(`talka_business/cancel/${data.id}`, data)
      .then(respo => {
        if (respo.status === 200) {
          commit('updateOrderDetail', respo.data.data);
          commit('loadingFinish', null, {root: true});

        }
      })
      .catch(error => {
        commit('loadingFinish', null, {root: true});
        throw error;
      },);
  },

  async addExtraPrice({commit}, data) {
    commit('loadingStart', null, {root: true});

    await this._vm.$http
      .post(`talka_business/add_extra_price/${data.id}`, {order_id: data.id, extra_price: data.extra_price, extra_price_notes: data.extra_price_notes})
      .then(respo => {
        if (respo.status === 200) {

          commit('updateOrderDetail', respo.data.data);
          commit('loadingFinish', null, {root: true});

        }
      })
      .catch(error => {
        commit('loadingFinish', null, {root: true});
        throw error;
      },);
  },

  async calculateDeliveryPrice({ commit }, data) {
    commit('loadingStart', null, {root: true});

    await this._vm.$http
      .post(`talka_business/calculate_delivery_price`, data)
      .then(respo => {
        if (respo.status === 200) {

          commit('setCalculatedDeliveryPrice', respo.data.data);
          commit('loadingFinish', null, {root: true});

        }
      })
      .catch(error => {
        commit('loadingFinish', null, {root: true});
        throw error;
      },);
  },

    async exportExcel({commit}, data) {
        commit('loadingStart', null, {root: true});


        await this._vm.$http
            .get(`users/${data.type}/export-excel`, {responseType: 'blob'})
            .then(respo => {
                if (respo.status === 200) {
                    // commit('setData', respo.data.data);
                    const url = window.URL.createObjectURL(new Blob([respo.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', data.type + '.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async importExcel({commit, dispatch}, data) {
        commit('loadingStart', null, {root: true});


        return await this._vm.$http
            .post(`users/${data.type}/import-excel`, data)
            .then(respo => {
                if (respo.status === 200) {

                    commit('loadingFinish', null, {root: true});
                    return true;
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async simpleDetail({commit}, data) {
        commit('loadingStart', null, {root: true});

        await this._vm.$http
            .get(`users/${data.type}/simple/${data.id}`)
            .then(respo => {
                if (respo.status === 200) {
                    console.log(respo.data.data);
                    commit('setDetail', respo.data.data);

                    commit('loadingFinish', null, {root: true});

                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },
    async unsetDetail({commit}) {
        commit('unsetDetail');
    },

    async toggle({commit}, data) {
        commit('loadingStart', null, {root: true});


        return await this._vm.$http
            .post(`users/toggle`, data)
            .then(respo => {
                if (respo.status === 200) {
                    commit('updateData', respo.data.data);

                    commit('successMessage', 'toggle', {root: true});
                    commit('loadingFinish', null, {root: true});
                    return respo.data.data
                }
            })
            .catch(error => {
                commit('failMessage', 'toggle', {root: true});
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async create({commit}, data) {
        commit('loadingStart', null, {root: true});
        // console.log(data);
        await this._vm.$http
            .post(`talka_business/save_order`, data)
            .then(respo => {
                console.log(respo);
                if (respo.status === 201 || respo.status === 200) {
                    router.push({name: `talqah-business-orders`, params: {lang: i18n.locale}});

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            });
    },

    async update({commit}, data) {
        commit('loadingStart', null, {root: true});
        await this._vm.$http
            .post(`users/${data.type}/update/${data.id}`, data)
            .then(respo => {
                if (respo.status === 200) {
                    router.push({name: `users-${data.type}`, params: {lang: i18n.locale}});
                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            });
    },


    async getVehicleTypes({commit}) {

        await this._vm.$http
            .get(`users/drivers/vehicle-types`)
            .then(respo => {
                if (respo.status === 200) {
                    commit('setVehicleTypes', respo.data.data);

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async getVendorCategories({commit}) {

        await this._vm.$http
            .get(`users/vendors/categories`)
            .then(respo => {
                if (respo.status === 200) {
                    commit('setVendorCategories', respo.data.data);

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },
    async getVendorClassification({commit}, id) {

        await this._vm.$http
            .get(`users/vendors/classifications/${id}`)
            .then(respo => {
                if (respo.status === 200) {
                    commit('setVendorClassification', respo.data.data);

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async resetVendorPassword({commit}, id) {
        commit('loadingStart', null, {root: true});
        return await this._vm.$http
            .post(`users/vendors/reset-password/${id}`)
            .then(respo => {
                if (respo.status === 200) {

                    commit('loadingFinish', null, {root: true});
                }
                return respo.data.data;
            })
            .catch(error => {

                commit('loadingFinish', null, {root: true});
                throw error;
            });
    },

};
